import { z } from 'zod';
export const personaConfigSchema = z.object({
    name: z.string().min(1).max(50).optional(),
    voiceName: z.string().optional(),
    voiceStyle: z.string().max(500).optional(),
    voiceAccent: z.string().max(500).optional(),
    personality: z.string().max(500).optional(),
    voiceGuidance: z.string().max(500).optional(),
    chattiness: z.enum(['minimal', 'moderate', 'chatty']).optional(),
    responseLength: z.enum(['brief', 'normal', 'detailed']).optional(),
    respondToName: z.boolean().optional(),
    respondToQuestions: z.boolean().optional(),
    visionInterjectionEnabled: z.boolean().optional(),
    customInstructions: z.string().max(1000).optional(),
    eventResponseStyle: z.enum(['witty', 'thankful', 'hype', 'roast', 'custom']).optional(),
    eventResponseStyleCustom: z.string().max(500).optional(),
    avoidTopics: z.array(z.string()).optional(),
    streamType: z.string().max(50).optional(),
    streamerName: z.string().max(50).optional(),
    additionalContext: z.string().max(500).optional(),
});
export const triggerConfigSchema = z.object({
    donations: z.object({
        enabled: z.boolean().optional(),
        minimumBits: z.number().min(0).optional(),
        readUsername: z.boolean().optional(),
        readAmount: z.boolean().optional(),
        maxMessageLength: z.number().min(1).max(1000).optional(),
    }).optional(),
    chatAlerts: z.object({
        enabled: z.boolean().optional(),
        velocityThreshold: z.number().min(1).optional(),
        velocitySustainedSeconds: z.number().min(1).optional(),
        similarityThreshold: z.number().min(0).max(1).optional(),
        minimumClusterSize: z.number().min(2).optional(),
        ignoreEmoteOnlyMessages: z.boolean().optional(),
        ignoreShortMessages: z.boolean().optional(),
        ignoredPhrases: z.array(z.string()).optional(),
        urgentKeywords: z.array(z.string()).optional(),
    }).optional(),
    cooldowns: z.object({
        afterDonation: z.number().min(0).optional(),
        afterChatAlert: z.number().min(0).optional(),
        afterAnyResponse: z.number().min(0).optional(),
    }).optional(),
    channelPoints: z.object({
        enabled: z.boolean().optional(),
        rewardIds: z.array(z.string()).optional(),
    }).optional(),
    commands: z.object({
        enabled: z.boolean().optional(),
        prefix: z.string().optional(),
        allowedCommands: z.array(z.string()).optional(),
        modOnly: z.boolean().optional(),
        allowViewerMessages: z.boolean().optional(),
        cooldown: z.number().min(0).optional(),
        sendCooldownMessages: z.boolean().optional(),
    }).optional(),
});
export const streamlabsConfigSchema = z.object({
    enabled: z.boolean().optional(),
    socketToken: z.string().max(500).optional(),
    pauseDuringAlerts: z.boolean().optional(),
});
export const profanityFilterConfigSchema = z.object({
    enabled: z.boolean().optional(),
    useDefaultList: z.boolean().optional(),
    customWords: z.array(z.string().max(200)).max(500).optional(),
    whitelistedWords: z.array(z.string().max(100)).max(100).optional(),
});
export const viewerMemoryConfigSchema = z.object({
    enabled: z.boolean().optional(),
});
export const streamerMemoryConfigSchema = z.object({
    enabled: z.boolean().optional(),
});
export const adaptiveResponseConfigSchema = z.object({
    enabled: z.boolean().optional(),
    profile: z.enum(['conservative', 'balanced', 'aggressive']).optional(),
    learningRate: z.number().min(0).max(1).optional(),
    explorationRate: z.number().min(0).max(1).optional(),
});
export const aiGuardrailConfigSchema = z.object({
    strictMode: z.boolean().optional(),
    allowIdleVisionMemoryWrites: z.boolean().optional(),
    allowIdleVisionViewerMemoryWrites: z.boolean().optional(),
    // Backward compatibility for older stored/client keys.
    allowMemoryWritesInPassivePtt: z.boolean().optional(),
    allowViewerMemoryWritesInPassivePtt: z.boolean().optional(),
    maxToolCallsPerTurn: z.number().min(1).max(10).optional(),
});
export const bulkUpdateSchema = z.object({
    channelName: z.string().max(100).optional(),
    persona: personaConfigSchema.optional(),
    triggers: triggerConfigSchema.optional(),
    audio: z.object({
        pushToTalk: z.object({
            enabled: z.boolean().optional(),
            hotkey: z.string().optional(),
            hotkeyDisplay: z.string().optional(),
        }).optional(),
        deviceId: z.string().optional(),
        inputGain: z.number().optional(),
        outputVolume: z.number().optional(),
        visualsEnabled: z.boolean().optional(),
        overlayScale: z.number().min(0.5).max(5.0).optional(),
        onDemandVision: z.boolean().optional(),
    }).optional(),
    streamlabs: streamlabsConfigSchema.optional(),
    profanityFilter: profanityFilterConfigSchema.optional(),
    viewerMemory: viewerMemoryConfigSchema.optional(),
    streamerMemory: streamerMemoryConfigSchema.optional(),
    adaptiveResponse: adaptiveResponseConfigSchema.optional(),
    aiGuardrails: aiGuardrailConfigSchema.optional(),
});
//# sourceMappingURL=schemas.js.map